import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { cn } from '../utils/classNames';

/**
 * Reassures buyers that the final amount is shown before paying —
 * no surprises, no hidden fees.
 */
export const SecurePaymentNote = ({
  className = ''
}: {
  className?: string;
}) => <div className={cn('mx-auto flex w-full max-w-sm flex-col items-center gap-1 rounded-2xl border border-emerald-500/25 bg-emerald-500/[0.06] px-4 py-3 text-center', className)} data-id="element-374" data-mp="1h8bvzp5v99p2">
    <p className="flex items-center justify-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-emerald-400" data-id="element-375" data-mp="1q8s1f4666qwk">
      <ShieldCheck size={14} className="shrink-0" aria-hidden="true" data-id="element-376" data-mp="1v0rtybjwuhj4" />
      Bezpieczna i przejrzysta płatność
    </p>
    <p className="text-xs leading-snug text-slate-300" data-id="element-377" data-mp="1zybjw8pz0iqw">
      Ostateczną kwotę zobaczysz przed zapłatą. Żadnych niespodzianek ani
      ukrytych opłat.
    </p>
  </div>;